import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

const button = cva(
	"inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors disabled:pointer-events-none disabled:opacity-40",
	{
		variants: {
			variant: {
				solid: "bg-accent text-accent-ink shadow-sm hover:bg-accent-strong",
				outline: "border border-line-strong text-ink hover:bg-raised",
				ghost: "text-ink-muted hover:bg-raised hover:text-ink",
			},
			size: {
				sm: "h-8 px-3 text-xs",
				md: "h-9 px-4 text-sm",
			},
		},
		defaultVariants: { variant: "solid", size: "md" },
	},
);

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof button>;

export const Button = ({ className, variant, size, ...props }: ButtonProps) => (
	<button className={cn(button({ variant, size }), className)} {...props} />
);
